import Splide from '@splidejs/splide';
import {
  Chart,
  DoughnutController,
  ArcElement,
  Legend,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js';

Chart.register(
  DoughnutController,
  ArcElement,
  Legend,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale
);

document.addEventListener('DOMContentLoaded', function () {
  // Sejda save as pdf btn
  document.getElementById('savePDF').addEventListener('click', function (e) {
    var pageUrl = encodeURIComponent(window.location.href);
    var opts = [
      'save-link=' + pageUrl,
      'pageOrientation=auto',
      'viewportWidth=1440',
      'delay=5',
      'usePrintMedia=true'
    ];
    window.open('https://www.sejda.com/html-to-pdf?' + opts.join('&'));
    e.preventDefault();
  });

  const splide = new Splide('.splide', {
    type: 'loop',
    perPage: 1,
    gap: 'var(--space-300)',
    focus: 'center',
    lazyLoad: 'nearby',
    mediaQuery: 'min',
    fixedWidth: 'var(--slide-width)',
    padding: 'var(--space-300)',
    breakpoints: {
      575: {
        focus: 'center'
      }
    }
  }).mount();

  window.addEventListener('beforeprint', event => {
    splide.destroy();
  });

  window.addEventListener('afterprint', event => {
    splide.mount();
  });

  // Donut
  const doughnut = document.getElementById('demographics');
  if (doughnut) {
    const men = doughnut.getAttribute('data-men');
    const women = doughnut.getAttribute('data-women');
    new Chart(doughnut, {
      type: 'doughnut',
      events: [],
      data: {
        labels: [`Men (${men}%)`, `Women (${women}%)`],
        datasets: [
          {
            data: [men, women],
            backgroundColor: ['rgba(206, 83, 74, 1)', 'rgba(194, 40, 29, 1)'],
            hoverBackgroundColor: ['rgba(206, 83, 74, 1)', 'rgba(194, 40, 29, 1)'],
            borderWidth: 0
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'rgba(255,255,255,0.8)',
              font: {
                size: 14
              }
            }
          }
        }
      }
    });
  }

  const bar = document.getElementById('age');
  if (bar) {
    const bar_attributes = Object.values(bar.attributes).filter(value =>
      value.name.includes('data-age')
    );

    if (bar_attributes.length) {
      const bar_labels = bar_attributes.map(attr => attr.name.replace('data-age-', ''));
      const bar_data = bar_attributes.map(attr => attr.value);
      new Chart(bar, {
        type: 'bar',
        data: {
          labels: bar_labels,
          datasets: [
            {
              data: bar_data,
              backgroundColor: 'rgba(194, 40, 29, 1)',
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: false
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                color: 'rgba(255,255,255,0.8)',
                font: {
                  size: 14
                },
                callback: function (label, index, labels) {
                  return label + '%';
                }
              },
              grid: {
                display: true,
                color: 'rgba(255,255,255,0.2)'
              }
            },
            x: {
              ticks: {
                color: 'rgba(255,255,255,0.8)',
                font: {
                  size: 14
                }
              }
            }
          }
        }
      });
    }
  }
});
